const PWA_METADATA = {
  en: {
    title: 'English PT Club',
    manifest: 'manifest.en.json',
    description: 'English PT Club - REP & SPEAK, English speaking training through repetition',
  },
  ko: {
    title: '\uC601\uC5B4\uD6C8\uB828\uC18C',
    manifest: 'manifest.ko.json',
    description: '\uC601\uC5B4\uD6C8\uB828\uC18C - \uB0AD\uB3C5\uD558\uB77C \uADF8\uB9AC\uACE0 \uBC18\uBCF5\uD558\uB77C',
  },
};

function ensureMeta(name) {
  let element = document.head.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    document.head.appendChild(element);
  }
  return element;
}

export function applyLocalizedPwaMetadata(language) {
  if (typeof document === 'undefined') return;

  const normalizedLanguage = Object.prototype.hasOwnProperty.call(PWA_METADATA, language) ? language : 'en';
  const metadata = PWA_METADATA[normalizedLanguage];
  const publicUrl = String(process.env.PUBLIC_URL || '').replace(/\/$/, '');
  let manifestLink = document.head.querySelector('link[rel="manifest"]');

  if (!manifestLink) {
    manifestLink = document.createElement('link');
    manifestLink.setAttribute('rel', 'manifest');
    document.head.appendChild(manifestLink);
  }

  manifestLink.setAttribute('href', `${publicUrl}/${metadata.manifest}`);
  document.documentElement.setAttribute('lang', normalizedLanguage);
  document.title = metadata.title;
  ensureMeta('application-name').setAttribute('content', metadata.title);
  ensureMeta('apple-mobile-web-app-title').setAttribute('content', metadata.title);
  ensureMeta('description').setAttribute('content', metadata.description);
}

export default applyLocalizedPwaMetadata;
